'use strict';

exports.Buffer = require('./Buffer');
exports.InputBuffer = require('./InputBuffer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/iobuffer/src/iobuffer.js
 ** module id = 3
 ** module chunks = 0
 **/